import Cookies from 'js-cookie';
const paramList = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

class CookiesClass {
  constructor() {
    this.saved = false;
    this.array = [];
    this.object = {};

    this.init();
  }

  init() {
    const params = new URLSearchParams(window.location.search);
    
    if (Cookies.get('dk_source')) {
      this.array = [JSON.parse(Cookies.get('dk_source'))];
    };

    if (params.toString().length > 0) {
      paramList.forEach(param => {
        if (params.get(param)) {
          this.object[param] = params.get(param);
        }
      })

      const newObject = this.object;
      newObject['date'] = new Date();

      const newList = this.array.concat([this.object]);
      Cookies.set('dk_source', JSON.stringify(newList), { expires: 30, domain: '.doijerkalff.nl' });
    }
  }
}

export default CookiesClass;
